export default "__VITE_ASSET__kK6Q6yvx__"